<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du compte</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div v-if="has_identity_picture" class="text-center mb-3 ">
          <b-image class="mb-1 picture" :src="identity_picture" thumbnail/>
          <d-link :href="identity_picture" target="_blank">
            Ouvrir la photo d'identification <i class="fa fa-external-link-alt"></i>
          </d-link>
        </div>
        <div v-else class="text-center text-dark">
          <b-alert show variant="warning">La photo d'identification n'est pas encore été soumise</b-alert>
        </div>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Nom" v-model="last_name" :state="lastNameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Prénom" v-model="first_name" :state="firstNameState">
              Veuillez saisir un prénom
            </c-input>
            <div>
              <b-form-group label="Genre" class="label_gender">
                <b-form-radio-group
                  v-model="gender"
                  :options="gender_options"
                  class="mb-3"
                  text-field="text"
                  value-field="value"
                  disabled-field="notEnabled">
                </b-form-radio-group>
              </b-form-group>
            </div>
            <c-input type="date" container-class="mb-3" label="Date de naissance" v-model="birth_date"/>
            <c-input container-class="mb-3" label="Numéro de téléphone" v-model="phone_number" disabled/>
            <c-input container-class="mb-3" label="Identifiant" v-model="username" disabled/>
            <c-input container-class="mb-3" label="Adresse email" v-model="email" disabled/>
            <c-input type="date" container-class="mb-3" label="Date d'inscription" v-model="created_at" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Solde du compte"
                     v-model="balance" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input container-class="mb-3" type="select" label="Type de la pièce d'identité"
                     v-model="identity_type" :options="identity_type_options" selected>
              Veuillez sélectionner un type
              <template slot="first">
                <option :value="null" disabled>-- Sélectionnez un type --</option>
              </template>
            </c-input>
            <c-input container-class="mb-3" label="Numéro de la pièce d'identité" v-model="identity_number"/>
            <c-input type="date" container-class="mb-3" label="Date d'expiration de la pièce d'identité"
                     v-model="identity_expire_date"/>
            <c-input type="textarea" container-class="mb-3" label="Raison du rejet" v-model="comment"/>

            <b-form-group>
              <label class="font-weight-bold mb-0">Pièce d'identité photo1 </label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="identity_file1" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="identity_file1" target="_blank" :disabled="!has_identity_file1">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>

            <b-form-group v-if="selectedItem.kyc.identity_type === 'CNI'">
              <label class="font-weight-bold mb-0">Pièce d'identité photo2 </label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="identity_file2" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="identity_file2" target="_blank" :disabled="!has_identity_file2">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>

            <c-input type="datetime" container-class="mb-3" label="Date d'approbation de l'identité"
                     v-model="accepted_at" disabled/>
            <d-form-checkbox v-model="accepted_identity_picture">
              Accepter la photo d'identification
            </d-form-checkbox>
            <d-form-checkbox v-model="accepted_identity_file1">
              Accepter la pièce d'identité photo1
            </d-form-checkbox>
            <d-form-checkbox v-model="accepted_identity_file2" v-if="selectedItem.kyc.identity_type === 'CNI'">
              Accepter la pièce d'identité photo2
            </d-form-checkbox>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <!--d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par identifiant, nom ou tél..." v-model="search"/>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon">
              <i class="fa fa-search"></i>
            </template>
            Rechercher
          </c-button-spinner>
        </d-input-group-->
        <d-row>
          <d-col class="col-4">
            <c-input container-class="mb-3" type="select" label="Type de compte"
                     v-model="identity_verification_type" :options="identity_verification_options" selected>
              Veuillez sélectionner un type
              <template slot="first">
                <option :value="null" disabled>-- Sélectionnez un type --</option>
              </template>
            </c-input>
          </d-col>

          <d-col class="col-4 mt-4 offset-4">
            <d-input-group class="justify-content-center">
              <c-input placeholder="Rechercher par identifiant, nom ou tél..." v-model="search"/>
              <d-input-group-append>
                <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                                  @click="onSearchSubmit">
                  <template slot="icon">
                    <i class="fa fa-search"></i>
                  </template>
                  Rechercher
                </c-button-spinner>
              </d-input-group-append>
            </d-input-group>
          </d-col>
        </d-row>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucun compte trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, Toast, truncate} from "@/helpers"

export default {
  title: "Vérification des identités",
  data() {
    return {
      search: '',
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'name', label: 'Nom', sortable: true},
        {key: 'username', label: 'Identifiant', sortable: true},
        {key: 'phone_number_pretty', label: 'Num. de tél.', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'roles_pretty', label: 'Rôle(s)', sortable: true},
        {key: 'created_at', label: 'Inscrit(e) le', sortable: true},
        {key: 'updated_at_pretty', label: 'Modifié le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du compte", handler: this.onItemSelect},
      ],

      modalVisible: false,
      selectedItem: null,
      birth_date: '',
      enabled: true,
      verified: false,
      submitted: false,
      fetchingFormSubmit: false,

      first_name: '',
      last_name: '',
      username: '',
      comment: '',
      identity_type: null,
      identity_number: '',
      identity_expire_date: '',
      accepted_identity_picture: false,
      accepted_identity_file1: false,
      accepted_identity_file2: false,
      gender: 'M',
      gender_options: [
        {text: 'Masculin', value: 'M'},
        {text: 'Feminin', value: 'F'},
      ],
      identity_verification_type: false,
      identity_type_options: [{text: 'CNI', value: 'CNI'}, {text: 'PASSPORT', value: 'PASSPORT'}],
      identity_verification_options: [{text: 'Compte vérifié', value: true}, {text: 'Compte à vérifier', value: false}],
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return (item.first_name + ' ' + item.last_name).toLowerCase().includes(search)
          || item.username.toLowerCase().includes(search)
          || (item.phone_number || '').includes(search)
          || (item.email || '').includes(search)
      })
    },
    lastNameState() {
      return this.last_name.length >= 2
    },
    firstNameState() {
      return this.first_name.length >= 2
    },
    itemSelected() {
      return !!this.selectedItem
    },
    phone_number() {
      return this.itemSelected ? formatAmount(this.selectedItem.phone_number) : ''
    },
    email() {
      return this.itemSelected ? this.selectedItem.email : ''
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ''
    },
    accepted_at() {
      return this.itemSelected ? this.selectedItem.kyc.accepted_at : ''
    },
    balance() {
      return this.itemSelected ? this.selectedItem.balance : ''
    },
    has_identity_picture() {
      return this.itemSelected && this.selectedItem.kyc.identity_picture_path
    },
    identity_picture() {
      return this.has_identity_picture ? this.selectedItem.kyc.identity_picture_path : null
    },
    has_identity_file1() {
      return this.itemSelected && this.selectedItem.kyc.identity_file1_path
    },
    identity_file1() {
      return this.has_identity_file1 ? this.selectedItem.kyc.identity_file1_path : '-- Aucun fichier --'
    },
    has_identity_file2() {
      return this.itemSelected && this.selectedItem.kyc.identity_file2_path
    },
    identity_file2() {
      return this.has_identity_file2 ? this.selectedItem.kyc.identity_file2_path : '-- Aucun fichier --'
    },
  },

  watch: {
    identity_verification_type() {
      this.loadKycList(this.identity_verification_type)
    }
  },
  created() {
    this.loadKycList(this.identity_verification_type)
  },

  methods: {
    loadKycList(kyc_status) {
      this.fetchingData = true
      Api.get('/kyc/list', {verified: kyc_status})
        .then(response => {
          this.data = response.data.users.map(this.mapItem)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingData = false)
    },

    mapItem(item) {
      return {
        ...item,
        name: truncate(item.first_name + ' ' + item.last_name, 20) + (item.enabled ? '' : ' 🚫'),
        phone_number_pretty: formatAmount(item.phone_number),
        balance_pretty: formatAmount(item.balance),
        roles_pretty: item.roles.map(r => r.name).join(', '),
        updated_at_pretty: item.kyc.updated_at.replace(' ', '\n'),
        status: item.verified ? "Vérifié" : item.identity_file ? "En attente..." : "Non vérifié",
        statusVariant: item.verified ? "success" : item.identity_file ? "warning" : "secondary",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.first_name = item.first_name
      this.last_name = item.last_name
      this.gender = item.gender
      this.birth_date = item.birth_date
      this.username = item.username
      this.identity_expire_date = item.kyc.identity_expire_date
      this.verified = item.verified
      this.enabled = item.enabled
      this.identity_type = item.kyc.identity_type
      this.identity_number = item.kyc.identity_no
      this.identity_expire_date = item.kyc.identity_expire_date
      this.accepted_identity_picture = item.kyc.identity_picture_accepted
      this.accepted_identity_file1 = item.kyc.identity_file1_accepted
      this.accepted_identity_file2 = item.kyc.identity_file2_accepted
      this.accepted_at = item.kyc.accepted_at
      this.comment = item.kyc.comment
      this.modalVisible = true
    },

    clearFields() {
      this.first_name = ''
      this.last_name = ''
      this.gender = 'F'
      this.birth_date = ''
      this.username = ''
      this.identity_expire_date = ''
      this.verified = false
      this.enabled = true
      this.identity_type = 'CNI'
      this.identity_number = ''
      this.identity_expire_date = ''
      this.accepted_at = ''
      this.accepted_identity_picture = false
      this.accepted_identity_file1 = false
      this.accepted_identity_file2 = false
      this.comment = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    onOpenIDFile(file) {
      const link = file === 'file1'
        ? this.selectedItem.kyc.identity_file1_path
        : file === 'file2'
          ? this.selectedItem.kyc.identity_file2_path
          : this.selectedItem.kyc.identity_picture_path
      window.open(link, '_blank')
    },
    isFormValid() {
      if (this.accepted_identity_file1 === true
        && this.accepted_identity_file2 === true
        && this.accepted_identity_picture === true) {
        this.comment = ''
      }

      return this.first_name.length >= 2 && this.last_name.length >= 2
    },
    onFormSubmit() {
      if (!this.isFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/kyc/validate ', {
        kyc_id: this.selectedItem.kyc.id,
        identity_file1_accepted: this.accepted_identity_file1,
        identity_file2_accepted: this.accepted_identity_file2,
        identity_picture_accepted: this.accepted_identity_picture,
        last_name: this.last_name,
        first_name: this.first_name,
        gender: this.gender,
        identity_no: this.identity_number,
        birth_date: this.birth_date,
        identity_expire_date: this.identity_expire_date,
        comment: this.comment
      })
        .then(res => {
          const user = this.mapItem(res.data)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, user)

          this.onModalClose()

          Toast.success(`Les infomations de l'utilisateur "${user.username}" a été mis à jour avec succès !`)

        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/user/find', {search: this.search})
        .then(res => this.data = res.data.users.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },

  }
}
</script>

<style scoped>
.picture {
  max-height: 200px;
}

/*.picture-bloc{
  background-color: #00578A;
  margin: auto;
  width: 50%;
  border-radius: 5px;
}*/

.label_gender {
  font-weight: bold;
}
</style>
